import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { useParams } from "react-router";

import InviteCreatePassword from "components/auth/InviteCreatePassword";
import * as api from "api/endpoints/userMangement";
import { logIn } from "store/slices/authPages";
import VerifyUserInviteOtp from "components/auth/VerifyUserInviteOtp";

export default function VerifyInvitePage() {
  const dispatch = useDispatch();
  const params = useParams();
  const navigate = useNavigate();
  const [otp, setOtp] = useState(null);
  const [userVerified, setUserVerified] = useState(false);
  const [otpVerifyLoading, setOtpVerifyLoading] = useState(false);
  const [showNotification, setShowNotification] = useState({ type: "", message: "" });

  const requestId = params.requestId;

  useEffect(() => {
    if (!requestId) {
      navigate("/");
    }
  }, [requestId, navigate]);

  async function handleValidateOtp(otp) {
    const data = {
      requestId: requestId,
      verificationCode: otp
    };

    setOtpVerifyLoading(true);

    try {
      const response = await api.verifyOtp(data);
      if (response.details?.isOTPEnteredValid) {
        setOtp(otp);
        setUserVerified(true);
      }
    } catch (err) {
      setShowNotification({ type: "error", message: err.response.data.errors });
    } finally {
      setOtpVerifyLoading(false);
    }
  }

  async function handleCreateUser(password) {
    const data = {
      requestId: requestId,
      password: password,
      verificationCode: otp
    };

    const response = await api.createUser(data);

    if (response.details.isEPAccountCreated) {
      await dispatch(logIn(response.details.email, password));
    }
  }

  function handleAlertClose() {
    setShowNotification({ type: "", message: "" });
  }

  return (
    <>
      {!userVerified && (
        <VerifyUserInviteOtp
          loading={otpVerifyLoading}
          showResend={false}
          showNotification={showNotification}
          onSubmit={handleValidateOtp}
          onAlertClose={handleAlertClose}
        />
      )}
      {userVerified && <InviteCreatePassword onSubmit={handleCreateUser} />}
    </>
  );
}
